import React, { useEffect, useState, useRef } from "react";
import { Spinner, Container, Row, Col, FormLabel as Label, Button, Table, Accordion } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showToast as toast } from "../toastManager";
import errorMessages from "../errorMessages.js";
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import axios from "axios";
import Cookies from 'js-cookie';
import {MultiSelect} from 'react-multi-select-component';
import { v4 as uuidv4 } from 'uuid';
import { Chart } from 'react-google-charts';
import Breadcrumbs from '../components/Breadcrumbs';

function MetaAdsPersonalization({ ViewedPage, shop_domain, app_url }) {
    ViewedPage(28);
    const location = useLocation();
    const navigate = useNavigate();
    const previousPage = location.state?.previousPage || 'campaign-summary';
    const campaignData = location.state?.campaignData;
    const targetingItem = location.state?.targetingItem;

    // State to track loading status
    const [loading, setLoading] = useState(true);
    const [show_generated_preview_page, setShowGeneratedPreviewPage] = useState(false);
    const [generate_btn_loading, setGenerateBtnLoading] = useState(false);
    const [apply_customization_btn_loading, setApplyCustomizeBtnLoading] = useState(false);
    const [raw_meta_ads_data, setRawMetaAdsData] = useState([]);
    const [bulk_apply_selected_ads, setBulkApplySelectedAds] = useState([]);
    const [all_meta_ad_dropdown_options, setAllMetaAdDropdownOptions] = useState([]);
    const [selected_meta_ad, setSelectedMetaAd] = useState({});
    const [selected_meta_ad_creative, setSelectedMetaAdCreative] = useState({});
    const [spreadsheet_url, setSheetUrl] = useState("");
    const [updated_exp_url, setUpdatedExperienceURL] = useState("");
    const [selected_meta_ad_title, setSelectedMetaAdTitle] = useState("");
    const [selected_meta_ad_description, setSelectedMetaAdDescription] = useState("");
    const [selected_image, setSelectedImage] = useState("");
    const [galleryImages, setGalleryImages] = useState([]);
    const [sortedMetaAdsData, setSortedMetaAdsData] = useState([]);

    // Add new state and ref for editable title
    const [isEditingName, setIsEditingName] = useState(false);
    const targetAndContentInputRef = useRef(null);
    const [target_and_content_name, setTargetAndContentName] = useState(targetingItem?.name || "Untitled Variant");

    // Add state for accordion
    const [activeAccordion, setActiveAccordion] = useState([]); // Default open first accordion

    // Add status state and options
    const [status, setStatus] = useState({ 
        value: targetingItem?.status || 'paused', 
        label: targetingItem?.status ? targetingItem.status.charAt(0).toUpperCase() + targetingItem.status.slice(1) : 'Paused' 
    });
    const statusOptions = [
        { value: 'enabled', label: 'Enabled' },
        { value: 'paused', label: 'Paused' }
    ];

    // Add useEffect to handle targeting item data
    useEffect(() => {
        if (targetingItem && all_meta_ad_dropdown_options.length > 0) {
            // Set the name
            setTargetAndContentName(targetingItem.name || "Untitled Variant");
            
            // Set the status
            setStatus({
                value: targetingItem.status || 'paused',
                label: targetingItem.status ? targetingItem.status.charAt(0).toUpperCase() + targetingItem.status.slice(1) : 'Paused'
            });
            
            // If targeting item has value array, set the title and description
            if (Array.isArray(targetingItem.value) && targetingItem.value.length >= 2) {
                setSelectedMetaAdTitle(targetingItem.value[0] || "");
                setSelectedMetaAdDescription(targetingItem.value[1] || "");
            }

            // If targeting item has targeting array, set the bulk apply selected ads
            if (Array.isArray(targetingItem.targeting)) {
                // Find matching ads from the dropdown options
                const matchingAds = targetingItem.targeting.map(adName => {
                    return all_meta_ad_dropdown_options.find(option => 
                        option.value.ad_name === adName
                    );
                }).filter(Boolean);
                
                if (matchingAds.length > 0) {
                    setBulkApplySelectedAds(matchingAds);
                    // Set the first ad as selected in the dropdown
                    setSelectedMetaAd(matchingAds[0]);
                    // Load initial data instead of calling handlePersonalizeExperience
                    loadInitialData();
                }
            }
        }
    }, [targetingItem, all_meta_ad_dropdown_options]);

    // Add useEffect to handle initial data load
    useEffect(() => {
        // Set loading state
        setLoading(true);
        try {
            if(Cookies.get('shop')){
                // Getting meta ads personalization data for last 60 days
                var created_at_max = new Date();
                created_at_max.setDate(created_at_max.getDate() - 1);
                var created_at_min = new Date(new Date().setDate(created_at_max.getDate() - 90));
                axios.post(app_url+"/api/facebook/meta_ads_personalization_data",{
                    shop_domain:shop_domain,
                    date_start:formatDate(created_at_min),
                    date_end:formatDate(created_at_max),
                    func_call_type:"redis",
                }, {withCredentials:true})
                .then(res => res.data)
                .then(data => {
                    // Successfully fetched data 
                    console.log(data)
                    // adding meta ads data
                    let temp_raw_meta_data =  data && data?.data && data?.data?.meta_ads_data ? data["data"]["meta_ads_data"] : []
                    setRawMetaAdsData(temp_raw_meta_data)
                    // adding meta ads dropdown options
                    let temp_all_dropdown_options = temp_raw_meta_data.map((iter) => {
                        return {"value":iter,"label":`${iter["ad_name"]} ( ${iter["adset_name"]} | ${iter["campaign_name"]} )`}
                    })
                    setAllMetaAdDropdownOptions(temp_all_dropdown_options)

                    // If we have targeting item data, don't set default selected ad
                    if (!targetingItem) {
                    // adding default meta ads
                    let temp_selected_data = temp_all_dropdown_options && temp_all_dropdown_options.length > 0 ? temp_all_dropdown_options[0] : {};
                    console.log("temp_selected_data",temp_selected_data)
                    setSelectedMetaAd(temp_selected_data)
                    }

                    setLoading(false)
                })
                .catch(err => {
                    // Failed in fetching data 
                    setLoading(false)
                    toast.error(`${errorMessages["DATA_PARSING_ERROR"]["title"]}`);
                    console.log(err);
                })
            }
        } catch (error) {
            setLoading(false)
            toast.error(`${errorMessages["DATA_LOAD_ERROR"]["title"]}`);
            console.log(error);
        }
    }, [shop_domain, app_url, targetingItem]);

    // Add useEffect to handle selected meta ad changes
    useEffect(() => {
        if (selected_meta_ad && selected_meta_ad.value) {
            // Remove the automatic loadInitialData call
            // loadInitialData();
        }
    }, [selected_meta_ad]);

    // Fetch gallery image URLs when raw_meta_ads_data or selected_image changes
    useEffect(() => {
        async function fetchGalleryImages() {
            if (!raw_meta_ads_data || raw_meta_ads_data.length === 0) {
                setGalleryImages([]);
                setSortedMetaAdsData([]);
                return;
            }
            // Sort the raw_meta_ads_data to put the selected ad first
            const sortedAds = [...raw_meta_ads_data].sort((a, b) => {
                if (a.creative_id === selected_image) return -1;
                if (b.creative_id === selected_image) return 1;
                return 0;
            });
            setSortedMetaAdsData(sortedAds);
            const urls = await Promise.all(
                sortedAds.map(ad => getCreativeUrl(shop_domain, ad.creative_id))
            );
            setGalleryImages(urls);
        }
        fetchGalleryImages();
    }, [raw_meta_ads_data, shop_domain, selected_image]);

    const handlePersonalizeExperience = async (e) => {
        if (e) {
        e.preventDefault();
        }
        setSelectedMetaAdCreative({})
        // Checking for empty or not having any value 
        if( (!selected_meta_ad) || (!selected_meta_ad?.value)){
            toast.error("Please select Meta Ad Name")
            return;
        }
        let temp_selected_meta_ad_details = selected_meta_ad["value"];
        console.log("temp_selected_meta_ad_details",temp_selected_meta_ad_details)
        if(temp_selected_meta_ad_details && Object.entries(temp_selected_meta_ad_details).length > 0){
            let creative_url = await getCreativeUrl(shop_domain, temp_selected_meta_ad_details["creative_id"])
            console.log(creative_url)
            setSelectedMetaAdTitle(temp_selected_meta_ad_details["title"])
            setSelectedMetaAdDescription(temp_selected_meta_ad_details["descriptor"])
            setSelectedImage(temp_selected_meta_ad_details["creative_id"])
            setSelectedMetaAdCreative({
                "title":temp_selected_meta_ad_details["title"],
                "description":temp_selected_meta_ad_details["descriptor"],
                "url":creative_url
            })
        }
    }

    // Add function to handle initial data load
    const loadInitialData = async () => {
        if (!selected_meta_ad || !selected_meta_ad?.value) {
            return;
        }
        let temp_selected_meta_ad_details = selected_meta_ad["value"];
        if(temp_selected_meta_ad_details && Object.entries(temp_selected_meta_ad_details).length > 0){
            let creative_url = await getCreativeUrl(shop_domain, temp_selected_meta_ad_details["creative_id"])
            setSelectedMetaAdTitle(temp_selected_meta_ad_details["title"])
            setSelectedMetaAdDescription(temp_selected_meta_ad_details["descriptor"])
            setSelectedImage(temp_selected_meta_ad_details["creative_id"])
            setSelectedMetaAdCreative({
                "title":temp_selected_meta_ad_details["title"],
                "description":temp_selected_meta_ad_details["descriptor"],
                "url":creative_url
            })
        }
    }
  
    const handleSaveDescriptionToSheet = async (is_drafted) => {
        setGenerateBtnLoading(true);  
        if(!selected_meta_ad_title || !selected_meta_ad_title.trim()){
            toast.error(`Please add Title`);
            setGenerateBtnLoading(false);  
            return;
        }
        if(!selected_meta_ad_description || !selected_meta_ad_description.trim()){
            toast.error(`Please add Description`);
            setGenerateBtnLoading(false);  
            return;
        }
        try {
            if(Cookies.get('shop')){
                handleCustomizePageSubmit(is_drafted);
                let customized_exp_sheet_data = []
                let updatedCampaignData = campaignData;

                if (is_drafted) {
                    customized_exp_sheet_data = [
                        [
                            formatDate(new Date()),
                            target_and_content_name,
                            status.label,
                            selected_meta_ad["value"]["campaign_name"],
                            selected_meta_ad["value"]["adset_name"],
                            selected_meta_ad["value"]["ad_name"],
                            campaignData.landing_page_urls,
                            selected_meta_ad_title,
                            selected_meta_ad_description,
                            await getCreativeUrl(shop_domain, selected_image),
                            encodeURI(
                                campaignData.landing_page_urls +
                                "?sxi_content=" +
                                (is_drafted
                                    ? `${selected_meta_ad["value"]["ad_id"]} (draft_${shop_domain.replace(".myshopify.com","")})`
                                    : selected_meta_ad["value"]["ad_id"]
                                )
                            )
                        ]
                    ];
                } else {
                    if (bulk_apply_selected_ads) {
                        customized_exp_sheet_data = await Promise.all(
                            bulk_apply_selected_ads.map(async (adOption) => [
                                formatDate(new Date()),
                                target_and_content_name,
                                status.label,
                                adOption.value.campaign_name,
                                adOption.value.adset_name,
                                adOption.value.ad_name,
                                campaignData.landing_page_urls,
                                adOption.value.title,
                                adOption.value.descriptor,
                                await getCreativeUrl(shop_domain, adOption.value.creative_id),
                                encodeURI(
                                    campaignData.landing_page_urls +
                                    "?sxi_content=" +
                                    (is_drafted
                                        ? `${adOption.value.ad_id} (draft_${shop_domain.replace(".myshopify.com","")})`
                                        : adOption.value.ad_id
                                    )
                                )
                            ])
                        );

                        // Check if we're editing an existing targeting item
                        if (targetingItem && targetingItem.id) {
                            // Get the creative URL first
                            const creativeUrl = await getCreativeUrl(shop_domain, selected_image);
                            
                            // Update existing targeting item
                            const updatedTargeting = await Promise.all(campaignData.targeting_and_content.map(async item => 
                                item.id === targetingItem.id 
                                    ? {
                                        ...item,
                                        name: target_and_content_name || 'Untitled Variant',
                                        status: status.value,
                                        targeting: bulk_apply_selected_ads.map(ad => ad.value.ad_name),
                                        value: [selected_meta_ad_title, selected_meta_ad_description, creativeUrl],
                                        lpPreview: encodeURI(
                                            campaignData.landing_page_urls +
                                            "?sxi_content=" +
                                            bulk_apply_selected_ads[0].value.ad_id
                                        )
                                    }
                                    : item
                            ));

                            updatedCampaignData = {
                                ...campaignData,
                                targeting_and_content: updatedTargeting
                            };
                        } else {
                            // Get the creative URL first
                            const creativeUrl = await getCreativeUrl(shop_domain, selected_image);
                            
                            // Create new targeting data only if we're not editing
                        const newId = uuidv4();
                        const newTargeting = {
                            id: newId,
                            name: target_and_content_name || 'Untitled Variant',
                                status: status.value,
                            targeting: bulk_apply_selected_ads.map(ad => ad.value.ad_name),
                                value: [selected_meta_ad_title, selected_meta_ad_description, creativeUrl],
                            lpPreview: encodeURI(
                                    campaignData.landing_page_urls +
                                "?sxi_content=" +
                                bulk_apply_selected_ads[0].value.ad_id
                            )
                        };

                        // Update campaign data with new targeting
                        updatedCampaignData = {
                            ...campaignData,
                            targeting_and_content: [
                                ...(campaignData?.targeting_and_content || []),
                                newTargeting
                            ]
                        };
                        }
                    }
                }

                // Getting Headers
                let headers = ["Date", "Variant Name", "Variant Status", "Campaign Name", "Ad Set Name", "Ad Name", "Landing Page URL", "Title", "Description", "Image URL", "Preview Link"];

                // Only send to sheet if not in draft mode
                if (!is_drafted) {
                    axios.post(app_url + "/api/shopify/send_landing_page_to_sheet", {
                        sheet_data: customized_exp_sheet_data,
                        sheet_name: campaignData.campaign_name,
                        headers: headers
                    }, {withCredentials: true})
                        .then(request => request.data)
                        .then(data => {
                            console.log(data)            
                            setUpdatedExperienceURL(encodeURI(
                                campaignData.landing_page_urls +
                                "?sxi_content=" +
                                (is_drafted
                                    ? `${selected_meta_ad["value"]["ad_id"]} (draft_${shop_domain.replace(".myshopify.com","")})`
                                    : selected_meta_ad["value"]["ad_id"]
                                )
                            ));
                            setSheetUrl(data["data"]["spreadsheetUrl"]);
                            toast.success("Added to Sheet");
                            setGenerateBtnLoading(false);
                            setApplyCustomizeBtnLoading(false);
                            setShowGeneratedPreviewPage(true);

                            // Navigate back with updated campaign data only for non-draft case
                            if (!is_drafted && bulk_apply_selected_ads) {
                                if (previousPage === 'personalization-campaign') {
                                    navigate('/personalization-campaign', {
                                        state: {
                                            campaignData: updatedCampaignData
                                        }
                                    });
                                } else {
                                    navigate('/campaign-summary', {
                                        state: {
                                            campaignData: updatedCampaignData
                                        }
                                    });
                                }
                            }
                        })
                        .catch(err => {
                            setGenerateBtnLoading(false);
                            setApplyCustomizeBtnLoading(false);
                            toast.error(`${errorMessages["SHEET_UPLOAD_FAILED"]["title"]}`);
                            console.log(err)
                        });
                } else {
                    // For draft mode, just update the UI state
                    setUpdatedExperienceURL(encodeURI(
                        campaignData.landing_page_urls +
                        "?sxi_content=" +
                        `${selected_meta_ad["value"]["ad_id"]} (draft_${shop_domain.replace(".myshopify.com","")})`
                    ));
                    setGenerateBtnLoading(false);
                    setApplyCustomizeBtnLoading(false);
                    setShowGeneratedPreviewPage(true);
                }
            }
        }catch(err){
            setGenerateBtnLoading(false);
            setApplyCustomizeBtnLoading(false);
            toast.error(`${errorMessages["SHEET_UPLOAD_FAILED"]["title"]}`);
            console.log(err)
        }
    }

    const handleCustomizePageSubmit = async (is_drafted) => {
        setApplyCustomizeBtnLoading(true);

        // Validation
        if (!selected_meta_ad_title || !selected_meta_ad_title.trim()) {
            toast.error("Please add Title");
            setApplyCustomizeBtnLoading(false);
            return;
        }
        if (!selected_meta_ad_description || !selected_meta_ad_description.trim()) {
            toast.error("Please add Description");
            setApplyCustomizeBtnLoading(false);
            return;
        }

        let adsToApply;
        if (is_drafted) {
            // Always use single selected ad for draft
            adsToApply = [selected_meta_ad];
        } else {
            // Use bulk if available, else single
            adsToApply = (bulk_apply_selected_ads && bulk_apply_selected_ads.length > 0)
                ? bulk_apply_selected_ads
                : [selected_meta_ad];
        }

        let feature_flag_keys = [];
        let feature_flag_values = [selected_meta_ad_title, selected_meta_ad_description, await getCreativeUrl(shop_domain, selected_image)];

        for (let adOption of adsToApply) {
            const ad = adOption.value || adOption;
            const key = is_drafted
                ? `${ad.ad_id} (draft_${shop_domain.replace(".myshopify.com", "")})`
                : `${ad.ad_id}`;
            feature_flag_keys.push(key);
        }

        axios.post(app_url + "/api/google/gb_feature_flag_update", {
            landing_page_url: campaignData.landing_page_urls,
            key: feature_flag_keys,
            value: feature_flag_values
        }, { withCredentials: true })
            .then(res => res.data)
            .then(data => {
                setApplyCustomizeBtnLoading(false);
                toast.success("Customization applied!");
            })
            .catch(err => {
                toast.error("Failed to apply customization");
                setApplyCustomizeBtnLoading(false);
                console.log(err);
            });
    };

    const handleBack = () => {
        if (previousPage === 'personalization-campaign') {
            navigate('/personalization-campaign', { state: { campaignData: campaignData } });
        } else {
            navigate('/campaign-summary');
        }
    };

    // Add status change handler
    const handleStatusChange = (selected) => {
        setStatus(selected);
    };

    // Add this useEffect near the other useEffect hooks
    useEffect(() => {
        window.handleRemoveAd = (adId) => {
            const updatedAds = bulk_apply_selected_ads.filter(ad => ad.value.ad_id !== adId);
            setBulkApplySelectedAds(updatedAds);
        };

        return () => {
            delete window.handleRemoveAd;
        };
    }, [bulk_apply_selected_ads]);

    return (
        <div className="main-container">
            {!shop_domain ? (
                <div className="go_to_shopify_admin_div">
                    <h5 style={{ display: 'inline-block' }}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
            ) : loading ? (
                <div className="main_conatiner_spinner">
                    <Spinner animation="border" />
                </div>
            ) : (
                <>
                    <Breadcrumbs campaignData={campaignData} />
                    <div className="main-title mt-4">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <div className="d-flex align-items-center">
                                {isEditingName ? (
                                    <input 
                                        type="text"
                                        className="form-control" 
                                        value={target_and_content_name}
                                        onChange={(e) => setTargetAndContentName(e.target.value)}
                                        onBlur={() => {
                                            setIsEditingName(false);
                                            if (!target_and_content_name?.trim()) {
                                                setTargetAndContentName("Untitled Variant");
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                setIsEditingName(false);
                                            }
                                        }}
                                        ref={targetAndContentInputRef}
                                        style={{ fontSize: '1.75rem', fontWeight: 'bold', width: 'auto', minWidth: '180px' }}
                                    />
                                ) : (
                                    <h2 style={{ marginBottom: 0, marginRight: '10px', fontSize: '1.75rem', fontWeight: 'bold' }}>{target_and_content_name}</h2>
                                )}
                                <button
                                    className="btn btn-sm btn-link p-0 ms-2"
                                    onClick={() => setIsEditingName(true)}
                                    style={{ marginTop: '5px' }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil" viewBox="0 0 16 16">
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                    </svg>
                                </button>
                            </div>
                            <Button 
                                variant="outline-secondary" 
                                onClick={handleBack}
                                style={{ display: 'flex', alignItems: 'center' }}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left me-2" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                                </svg>
                                Back
                            </Button>
                        </div>
                    </div>

                    <Container className='my-4' style={{marginLeft:"0 !important"}}>
                        <Row className="my-2">
                            <Col className="d-flex align-items-center">
                                <span className="fw-bold me-2">Status</span>
                                <div style={{ width: '150px' }}>
                                    <ReMultiSelect 
                                        closeMenuOnSelect={true}
                                        components={ReMultiSelectAnimated()}
                                        value={status}
                                        options={statusOptions}
                                        onChange={handleStatusChange}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Accordion className="mt-4" activeKey={activeAccordion} onSelect={(keys) => setActiveAccordion(keys)}>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <h5>Select Targeting and Modify Content</h5>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <Row className='justify-content-md-left' lg={2} xs={1}>
                            <Col className='p-2'>
                                <Label className="charts_filter_label">Select Ad Name</Label>
                                <br />
                                <ReMultiSelect 
                                    closeMenuOnSelect={true}
                                    components={ReMultiSelectAnimated()}
                                    value={selected_meta_ad}
                                    options={all_meta_ad_dropdown_options}
                                    onChange={(selected_vals) => {
                                        setSelectedMetaAd(selected_vals);
                                    }}
                                />
                            </Col>
                            <Col className="p-2 d-flex align-items-end">
                                <Button variant="success" className="d-flex align-items-center justify-content-center sxi_primary_blue_btn" onClick={handlePersonalizeExperience}>Personalize Experience</Button>
                            </Col>
                        </Row>
                        
                        { (selected_meta_ad_creative && Object.entries(selected_meta_ad_creative).length > 0) &&
                            <>
                                <Row className='justify-content-between my-4' lg={2} xs={1}>
                                    <Col className="d-flex flex-column" lg={8} sm={8}>
                                        <label style={{fontSize:"large", fontWeight:"bold"}}>Modify Page Elements</label>
                                        <div className="mt-3 flex-grow-1 d-flex flex-column" style={{backgroundColor:"white",padding:"1rem", borderRadius:"0.5rem" }}>
                                            <div className="my-2">
                                                <Label className="charts_filter_label">Headline</Label>
                                                <textarea
                                                    className='custom-input-landing-page'
                                                    style={{width:"100%", backgroundColor:"#edf1f4"}}
                                                    placeholder="Type here ..."
                                                    value={selected_meta_ad_title}
                                                                onChange={(e) => setSelectedMetaAdTitle(e.target.value)}
                                                />
                                            </div>
                                            <div className="my-2">
                                                <Label className="charts_filter_label">Description</Label>
                                                <textarea
                                                    className='custom-input-landing-page'
                                                    style={{width:"100%", backgroundColor:"#edf1f4"}}
                                                    placeholder="Type here ..."
                                                    value={selected_meta_ad_description}
                                                                onChange={(e) => setSelectedMetaAdDescription(e.target.value)}
                                                />
                                            </div>
                                            <div className="my-2">
                                                <Label className="charts_filter_label">Image Gallery</Label>
                                                <div style={{ 
                                                    display: 'flex', 
                                                    flexWrap: 'wrap', 
                                                    gap: '10px',
                                                    maxHeight: '130px',
                                                    overflowY: 'auto',
                                                    padding: '10px',
                                                    backgroundColor: '#edf1f4',
                                                    borderRadius: '4px'
                                                }}>
                                                    {galleryImages.map((imgUrl, index) => {
                                                        const ad = sortedMetaAdsData[index];
                                                        if (!ad) return null;
                                                        const isSelected = selected_image === ad.creative_id;
                                                        const isDefault = imgUrl.includes('no_preview_available.png');
                                                        if (isDefault) return null;
                                                        return (
                                                            <div key={index} style={{ position: 'relative', display: 'inline-block' }}>
                                                                <img
                                                                    src={imgUrl}
                                                                    alt={`Ad creative ${index + 1}`}
                                                                    style={{
                                                                        width: '100px',
                                                                        height: '100px',
                                                                        objectFit: 'cover',
                                                                        cursor: 'pointer',
                                                                        border: isSelected ? '4px solid #007bff' : '1px solid #ddd',
                                                                        borderRadius: '4px',
                                                                        boxShadow: isSelected ? '0 0 0 2px #007bff55' : 'none',
                                                                        filter: isSelected ? 'none' : 'grayscale(30%)',
                                                                        transition: 'border 0.2s, box-shadow 0.2s, filter 0.2s'
                                                                    }}
                                                                                onClick={() => setSelectedImage(ad.creative_id)}
                                                                />
                                                                {isSelected && (
                                                                    <span style={{
                                                                        position: 'absolute',
                                                                        top: '6px',
                                                                        right: '6px',
                                                                        background: '#007bff',
                                                                        color: 'white',
                                                                        borderRadius: '50%',
                                                                        width: '22px',
                                                                        height: '22px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                                                                        fontSize: '1.1rem',
                                                                        zIndex: 2
                                                                    }}>
                                                                        ✓
                                                                    </span>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className="d-flex flex-column" lg={4} sm={4}>                                
                                        <label style={{fontSize:"large", fontWeight:"bold"}}>Ad Creative Preview</label>
                                        <div className="mt-3 flex-grow-1 d-flex flex-column" style={{backgroundColor:"white",padding:"1rem", borderRadius:"0.5rem",}}>
                                            <h6 style={{ fontSize: "1rem", marginBottom: "0.5rem" }}>
                                                {selected_meta_ad_creative["title"]}
                                            </h6>
                                            <p style={{ fontSize: "0.95rem", marginBottom: "1rem" }}>
                                                {selected_meta_ad_creative["description"]}
                                            </p>
                                            <img
                                                src={selected_meta_ad_creative["url"]}
                                                alt=""
                                                style={{
                                                width: "100%",
                                                height: "auto",
                                                display: "block",
                                                margin: "0 auto",
                                                borderRadius: "6px",
                                                                maxHeight: "270px",
                                                objectFit: "contain",
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='justify-content-md-left' style={{margin:0}} lg={1} xs={1}>
                                    {generate_btn_loading ?
                                        <Button className="d-flex align-items-center justify-content-center sxi_primary_blue_btn" disabled><Spinner animation="border" size="sm" /></Button>
                                        :
                                        <Button className="d-flex align-items-center justify-content-center sxi_primary_blue_btn" onClick={(e) => { e.preventDefault(); handleSaveDescriptionToSheet(true)}}>Generate Preview</Button>
                                    }
                                </Row>

                                { (show_generated_preview_page && (updated_exp_url || spreadsheet_url)) &&
                                        <Row className='justify-content-md-left mt-3' lg={1} xs={1} style={{margin:0}}>
                                            <div className='px-3 py-4 mt-4' style={{width:"100%", backgroundColor:"white", color:"black", borderRadius:"5px"}} >
                                                Landing Page URL (Open in incognito mode) - 
                                                <Link to={updated_exp_url} target='_blank'>{updated_exp_url}</Link> 
                                            </div>
                                        </Row>
                                            }
                                        </>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <h5>Bulk Apply</h5>
                                </Accordion.Header>
                                <Accordion.Body>
                                                <Row className='justify-content-md-left mt-3' lg={1} xs={1}>
                                                    <Col className='p-2'>
                                                        <Label className="charts_filter_label">Select ads/ad sets/campaigns to bulk publish</Label>
                                                        <MultiSelect 
                                                            id="select_keyword_bulk_apply"
                                                            className='popup_filter_include_exclude'
                                                            valueRenderer={() => {
                                                            if (bulk_apply_selected_ads.length === 0) return "Select...";
                                                            return `${bulk_apply_selected_ads.length} item${bulk_apply_selected_ads.length > 1 ? 's' : ''} selected`;
                                                            }}
                                                            value={bulk_apply_selected_ads}
                                                            options={all_meta_ad_dropdown_options}
                                                            onChange={(selected_vals) => {
                                                            setBulkApplySelectedAds(selected_vals);
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                                
                                                {(bulk_apply_selected_ads && bulk_apply_selected_ads.length > 0) &&
                                                <>
                                            <Row className='justify-content-md-left mt-3' lg={1} xs={1}>
                                                    <br />
                                                    <Label className="charts_filter_label">Bulk Apply Preview</Label>
                                                    <div id='kio_bulk_apply_table' style={{maxHeight: "400px", overflow: "scroll", maxWidth: "100%"}}>
                                                    <Chart
                                                        chartType="Table"
                                                        width="100%"
                                                        data={[
                                                            ['Name', 'Status', 'Targeting', 'LP Preview URL', 'Actions'],
                                                            ...bulk_apply_selected_ads.map((adOption) => {
                                                                const ad = adOption.value;
                                                                return [
                                                                    ad.ad_name,
                                                                    'Draft',
                                                                    ad.ad_name,
                                                                    '-',
                                                                    `<div class="text-center">
                                                                        <button class="btn btn-sm btn-link p-0" onclick="window.handleRemoveAd('${ad.ad_id}')" title="Remove" style="color: #000">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                                                            </svg>
                                                                        </button>
                                                                    </div>`
                                                                ];
                                                            })
                                                        ]}
                                                        options={{
                                                            width: '100%',
                                                            curveType: "function",
                                                            legend: { position: "bottom" },
                                                            cssClassNames: {
                                                                tableCell: "channel_performance_table_cell",
                                                                headerCell: "channel_performance_header_cell",
                                                                tableRow: "channel_performance_table_row",
                                                                oddTableRow: "channel_performance_old_table_row"
                                                            },
                                                            allowHtml: true
                                                        }}
                                                    />
                                                    </div>
                                                </Row>
                                                <Row className='justify-content-md-left mt-3' lg={1} xs={1}>
                                                    <Col style={{textAlign:"left"}}>
                                                    {apply_customization_btn_loading ?
                                                        <Button className='mt-3 sxi_primary_blue_btn' disabled><Spinner animation="border" /></Button>
                                                    :
                                                        <Button className='mt-3 sxi_primary_blue_btn' onClick={(e) => {e.preventDefault();handleSaveDescriptionToSheet(false)}}>Publish</Button>
                                                    }
                                                    </Col>
                                                </Row>
                                                </>
                                                }
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Container>
                </>
            )}
        </div>
    );
}

export default MetaAdsPersonalization;


// Used to format Date in yyyy-mm-dd format
function formatDate(date, is_increase_date=false) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + (is_increase_date? d.getDate() + 1: d.getDate()),
      year = d.getFullYear();
  
    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
  
    return [year, month, day].join('-');
}


function checkIfImageExists(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
}

async function getCreativeUrl(shop_domain, creative_id) {
    let default_url = `https://storage.googleapis.com/scalex-ai/no_preview_available.png`;
    let temp_shop = shop_domain.replace(".myshopify.com", "");
    let img_url = `https://storage.googleapis.com/scalex-ai/scaleX_AI_${temp_shop}/Meta_Creative/${creative_id}`;

    const exists = await checkIfImageExists(img_url);
    return exists ? img_url : default_url;
}